import { Header_col, TableRow, ModTable, LsTable } from "core-lib";
// import { formatCurrency } from "@angular/common";
// import * as currencyFormatter from "currency-formatter";

const formatter = Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

export function formatTable(table: LsTable): ModTable {
  let headerRow = JSON.stringify(table.header_row[0]);
  if (headerRow.includes('<br&gt;')) {
    // NOTE: this fixes the incorrect lines break at the beginning of linescale guides
    headerRow = headerRow.replace(/<br&gt;/g, '');
  }

  return {
    ...table,
    // header_row: [...table.header_row[0]],
    header_row: JSON.parse(headerRow),
    // body: formatBody(table.header_row[0], table.body, {
    //     numberFormat: table.number_format
    // }),
    body: formatBody({
      // header: [...table.header_row[0]],
      header: table.header_row[0],
      body: table.body,
      numberFormat: table.number_format,
      rowFormat: table.use_row_formats,
      columnFormat: table.use_column_formats
    }),

    displayedCols: table.header_row[0].map(col => col.id)
  }
}

export function formatTables(result) {
  return result.map(item => {
    if (item.type === 'table') {
      const clone = deepClone(item);

      clone.header_row = item.header_row[0];
      clone.body = formatBody({
        header: item.header_row[0],
        body: item.body,
        numberFormat: item.number_format,
        rowFormat: item.use_row_formats || null,
        columnFormat: item.use_column_formats || null
      });
      clone.displayedCols = item.header_row[0].map(col => col.id);
      return clone;
    }
    return item;
  });

}

export function formatBody(options: {
  header: Header_col[],
  body: TableRow[],
  numberFormat: string,
  rowFormat?: boolean,
  columnFormat?: boolean
}): TableRow[] {
  const { body } = options;
  const header = options.header;
  const patt: RegExp = /c[0-9]/i;

  const dataCols: Header_col[] = header.filter(col => patt.test(col.id));

  const { numberFormat, rowFormat, columnFormat } = options;
  // console.log(columnFormat, numberFormat);

  if (columnFormat) {
    const modCols: {
      [id: string]: {
        id: string,
        cells: number[]
      }
      // TODO: Remove this double map which severely increases processing time
    } = dataCols.map(col => ({
      id: col.id,
      format: col.format,
      cells: body.map(row => Number(row[col.id]))
    })).map(col => ({
      ...col,
      cells: formatColumn(col.cells, col.format)
    })).reduce((cols, col) => ({
      ...cols,
      [col.id]: col
    }), {});

    return body.map((row, index) => {
      return Object.keys(row).map(key => ({
        id: key,
        value: (modCols[key]) ? modCols[key].cells[index] : row[key]
      })).reduce((row, col) => ({
        ...row,
        [col.id]: col.value
      }), {});
    });
  }
  if (rowFormat)
    return body.map(row => formatRow(row, dataCols));
  if (numberFormat === 'percent' || numberFormat === 'percent+' || numberFormat === 'percent.1') {
    console.log('This ran: Percent');
    const nextBody = body.map(row => formatRow(row, dataCols, numberFormat));
    // console.log(nextBody);

    return nextBody;
  }
  return body;

}

export function formatColumn(column: number[], format: string): number[] {
  switch (format) {
    case 'linescale.delta':
      return column;

    case 'linescale': {
      return column;
    }

    case 'percent+': {
      // TODO: Review this casting and number requirement.
      return column.map(cell => (Math.round(cell * 100) + '%') as any);
    }

    case 'percent': {
      return column.map(cell => Math.round(cell * 100));
    }

    case 'percent.1': {
      return column.map(cell => Math.round(cell * 1000) / 10);
    }

    case 'average':
      return column.map(cell => Math.floor(cell));

    default: {
      console.log('Other format', format);

    }
  }
  return column;
}


export function formatRow(row: TableRow, cols: Header_col[], tableFormat?: string): TableRow {
  const modRow: TableRow = Object.assign({}, row);
  const format: string = tableFormat ? tableFormat : row.row_format;

  // console.log('Formatting row...', format);


  switch (format) {
    case 'percent': {
      cols.forEach(col => modRow[col.id] = Math.round((modRow[col.id] as number) * 100));
      break;
    }
    case 'percent+': {
      cols.forEach(col => modRow[col.id] = Math.round((modRow[col.id] as number) * 100) + '%');
      break;
    }
    case 'percent.1': {
      cols.forEach(col => modRow[col.id] = Math.round((modRow[col.id] as number) * 1000) / 10);
      break;
    }
    case 'average': {
      cols.forEach(col => modRow[col.id] = Math.floor(modRow[col.id] as number));
      break;
    }
    case 'currency': {
      cols.forEach(col => {
        /*  const num: string = Math.round(modRow[col.id] as number) + '';
 
         let curr: string = '',
             x: number;
         for (x = num.length; x > 3; x -= 2) {
             curr = ',' + num.substring(x - 3, x) + curr;
         }
 
         modRow[col.id] = '$' + num.substring(0, x - 1) + curr; */
        const val: number = Math.floor(Number(modRow[col.id]));
        // modRow[col.id] = currencyFormatter.format(val, { code: 'USD', precision: 0 });
        modRow[col.id] = formatter.format(val);
      });
      break;
    }
    default:
      break;
  }

  return modRow;
}

function deepClone(stuff) {
  return JSON.parse(JSON.stringify(stuff));
}

export const FORMAT_TABLES = '[APP] Format Tables';
export const TABLES_FORMATTED = '[WORKER] Tables Formatted';

export class TablesFormatted {
  readonly type = TABLES_FORMATTED;

  constructor(public payload: any) { }
}

export const SAY_HI = '[APP] Hello';
export const REPLY = '[WORKER] How are you?';

export class Reply {
  readonly type = REPLY;

  constructor(public payload: string) { }
}

// TODO: Make this be the LoadLinescoreSuccess ngrx action. Migrate to "core" lib
export const LINESCORE_LOADED = '[WORKER] Linescore data loaded';
export class LinescoreLoaded {
  type = LINESCORE_LOADED;
  constructor(public payload: any) { }
}

export type WorkerAction = TablesFormatted | Reply | LinescoreLoaded;

export function testMe(name: string) {
  return `Reply to: ${name}`;
}
